import { isDuringQuizTake, isDuringQuizBuild } from '@instructure/quiz-common';
export var media = {
  'phone-break-point': 'only screen and (max-width: 48rem)',
  'tablet-break-point': 'only screen and (max-width: 64rem)'
};
export var onPhone = function onPhone() {
  var windowObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var mediaQueryString = media['phone-break-point'];
  return windowObj.matchMedia(mediaQueryString).matches;
};
export var onTablet = function onTablet() {
  var windowObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var mediaQueryString = media['tablet-break-point'];
  return !onPhone(windowObj) && windowObj.matchMedia(mediaQueryString).matches;
};
export var isQuizTaking = function isQuizTaking() {
  return isDuringQuizTake();
};
export var isQuizBuilding = function isQuizBuilding() {
  return isDuringQuizBuild();
};